import ChangePlan from "../pages/account/ChangePlan.vue";
import ChooseBillingPeriod from "../pages/account/changeplan/ChooseBillingPeriod.vue";
import SelectPlan from "../pages/account/changeplan/SelectPlan.vue";
import Summary from "../pages/account/changeplan/Summary.vue";
import Confirmation from "../pages/account/changeplan/Confirmation.vue";
import Account from "../pages/account/Account.vue";
import Overview from "../pages/account/Overview.vue";
import AdvancedSettings from "../pages/account/AdvancedSettings.vue";
import PlanAndBilling from "../pages/account/PlanAndBilling.vue";
import Default from "../pages/Default.vue";
import Maintenance from "../pages/Maintenance.vue";
import Main from "../pages/Main.vue";
import Login from "../pages/Login.vue";
import ForgotPassword from "../pages/login/ForgotPassword.vue";
import LoginForm from "../pages/login/LoginForm.vue";
import Register from "../pages/login/Register.vue";
import Dashboard from "../pages/dashboard/Dashboard.vue";
import CreateATimer from "../pages/create-a-timer/CreateATimer.vue";
import TimerDetails from "../pages/TimerDetails.vue";
import DashboardOverview from "../pages/dashboard/Overview.vue";
import PaymentReceipt from "../pages/PaymentReceipt.vue";
import ChangePassword from "../pages/login/ChangePassword.vue";
import store from "../store/store";

import VueRouter from "vue-router";

const routes = [
  {
    path: "/",
    redirect: "default",
  },
  {
    path: "/login",
    component: Login,
    children: [
      {
        path: "",
        component: LoginForm,
        name: "login",
      },
      {
        path: "/forgot-password",
        component: ForgotPassword,
        name: "forgot password",
      },
      {
        path: "/ForgotPassword",
        component: ChangePassword,
        name: "change password with token",
      },
      {
        path: "/register",
        component: Register,
        name: "register",
      },
    ],
  },
  {
    path: "/dashboard",
    component: Main,
    /**
     * ensures user is logged in to access dashboard
     * kicks user back to login screen if not
     */
    beforeEnter: (to, from, next) => {
      if (store.state.session.loggedIn === false) {
        next({ name: "login" });
      } else {
        next();
      }
    },
    children: [
      {
        path: "",
        component: Dashboard,
        children: [
          {
            path: "",
            component: DashboardOverview,
            name: "dashboard",
          },
          {
            path: "overview",
            component: DashboardOverview,
            name: "dashboard overview",
          },
        ],
      },
      {
        path: "create-a-timer",
        component: CreateATimer,
        name: "create a timer",
      },
      {
        path: "edit-timer",
        component: CreateATimer,
        name: "edit timer",
      },
      {
        path: "timer-details",
        component: TimerDetails,
        name: "timer details",
      },
      {
        path: "account",
        component: Account,
        children: [
          {
            path: "",
            component: Overview,
            name: "account",
          },
          {
            path: "overview",
            component: Overview,
            name: "overview",
          },
          {
            path: "advanced-settings",
            component: AdvancedSettings,
            name: "advanced settings",
          },
          {
            path: "plan-and-billing",
            component: PlanAndBilling,
            name: "plan and billing",
          },
        ],
      },
      {
        path: "change-plan",
        component: ChangePlan,
        children: [
          {
            path: "",
            component: SelectPlan,
            name: "change plan",
          },
          {
            path: "select-plan",
            component: SelectPlan,
            name: "select plan",
          },
          {
            path: "choose-billing-period/:subscriptionType",
            component: ChooseBillingPeriod,
            name: "choose billing period",
          },
          {
            path: "summary/:subscriptionType/:billingPeriod",
            component: Summary,
            name: "summary",
          },
          {
            path: "confirmation",
            component: Confirmation,
            name: "confirmation",
          },
        ],
      },
    ],
  },
  {
    path: "/payment-receipt",
    component: PaymentReceipt,
    name: "payment receipt",
  },
  { path: "/404", component: Default, name: "default" },
  { path: "/maintenance", component: Maintenance, name: "maintenance" },
  { path: "*", redirect: "/404" },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

// scroll to top of page when each new page is loaded
router.afterEach((to, from) => {
  if (to.name !== from.name) window.scrollTo(0, 0);
  if (window.location.hash) {
    // wait for next render cycle
    setTimeout(() => {
      const element = document.getElementById(
        window.location.hash.replace("#", "")
      );
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    });
  }
  store.commit("session/clearValidationAlerts");
});

export default router;
